import {
  DateRange,
  DateRangePicker,
  DateRangePickerProps,
  PickersShortcutsItem,
  SingleInputDateRangeField,
} from '@mui/x-date-pickers-pro';
import {
  startOfYear,
  endOfYear,
  startOfQuarter,
  endOfQuarter,
  addQuarters,
  subQuarters,
  addYears,
  subYears,
} from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const shortcutsItems: PickersShortcutsItem<DateRange<Date>>[] = [
  {
    label: 'currentYear',
    getValue: () => {
      const now = new Date();
      return [startOfYear(now), endOfYear(now)];
    },
  },
  {
    label: 'previousYear',
    getValue: () => {
      const date = subYears(new Date(), 1);
      return [startOfYear(date), endOfYear(date)];
    },
  },
  {
    label: 'nextYear',
    getValue: () => {
      const date = addYears(new Date(), 1);
      return [startOfYear(date), endOfYear(date)];
    },
  },
  {
    label: 'currentQuarter',
    getValue: () => {
      const date = new Date();
      return [startOfQuarter(date), endOfQuarter(date)];
    },
  },
  {
    label: 'previousQuarter',
    getValue: () => {
      const date = subQuarters(new Date(), 1);
      return [startOfQuarter(date), endOfQuarter(date)];
    },
  },
  {
    label: 'nextQuarter',
    getValue: () => {
      const date = addQuarters(new Date(), 1);
      return [startOfQuarter(date), endOfQuarter(date)];
    },
  },
  { label: 'reset', getValue: () => [null, null] },
];

export const DateRangeSelect = (props: DateRangePickerProps<Date>) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'UserAvailabilityList.dateRange' });

  const additionalProps: Pick<DateRangePickerProps<Date>, 'slotProps' | 'slots'> = useMemo(() => {
    return {
      slots: {
        field: SingleInputDateRangeField,
      },
      slotProps: {
        shortcuts: {
          items: shortcutsItems.map((item) => ({
            ...item,
            label: t(item.label),
          })),
        },
        actionBar: { actions: [] },
      },
    };
  }, [t]);

  return <DateRangePicker sx={{ width: 220 }} label={t('label')} calendars={2} {...props} {...additionalProps} />;
};
